import { useMemo, useState, useCallback } from 'react';

type useConnectionsPanelRes = {
	connectionsPanelActiveNodeLocalId: string | null;
	openConnectionsPanel: (localId: string) => void;
	setConnectionsPanelActiveNodeLocalId: (localId: string) => void;
	closeConnectionsPanel: (localId?: string) => void;
};

export const useConnectionsPanel = (): useConnectionsPanelRes => {
	const [connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId] = useState<
		string | null
	>(null);

	const openConnectionsPanel = useCallback(
		(localId: string) => {
			setConnectionsPanelActiveNodeLocalId(localId);
		},
		[setConnectionsPanelActiveNodeLocalId],
	);

	const closeConnectionsPanel = useCallback(
		(localId?: string) => {
			if (!localId || (localId && localId !== connectionsPanelActiveNodeLocalId)) {
				setConnectionsPanelActiveNodeLocalId(null);
			}
		},
		[connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId],
	);

	return useMemo(
		() => ({
			connectionsPanelActiveNodeLocalId,
			setConnectionsPanelActiveNodeLocalId,
			openConnectionsPanel,
			closeConnectionsPanel,
		}),
		[
			connectionsPanelActiveNodeLocalId,
			setConnectionsPanelActiveNodeLocalId,
			openConnectionsPanel,
			closeConnectionsPanel,
		],
	);
};
